// extracted by mini-css-extract-plugin
export default {"container":"TeamPlanEdition_container__6VfgF"};